import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ButtonComponent } from './button/button.component';
import { RolldownComponent } from './rolldown/rolldown/rolldown.component'
import { AppRoutingModule } from '../app.routing';
import { PdfViewerModule } from 'ng2-pdf-viewer';
import { TypeaheadModule } from 'ngx-bootstrap/typeahead';

import { TranslateModule } from '../i18n/translate.module';
import { NAV_DROPDOWN_DIRECTIVES } from './directives/nav-dropdown.directive';
import { SIDEBAR_TOGGLE_DIRECTIVES } from './directives/sidebar.directive';
import { AsideToggleDirective } from './directives/aside.directive';
import { FocusDirective } from './directives/focus.directive';
import { CommentModal } from 'app/shared/modals/comment-modal/comment-modal.component';
import { EditadoSheetQaModal } from 'app/shared/modals/editado-sheet-qa-modal/editado-sheet-qa-modal.component';
import { PendingPrintModal } from 'app/shared/modals/pending-print-modal/pending-print-modal.component';
import { PendingPrintCsModal } from 'app/shared/modals/pending-print-cs-modal/pending-print-cs-modal.component';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { ReprintModal } from './modals/reprint-modal/reprint-modal.component';
import { RfidReprintModal } from './modals/rfid-reprint-modal/rfid-reprint-modal.component';
import { QaOkayModal } from './modals/qa-okay-modal/qa-okay-modal.component';
import { SheetCountModal } from './modals/sheet-count-modal/sheet-count-modal.component';
import { WizardModal } from './modals/wizard-modal/wizard-modal.component';
import { AccessoryModal } from './modals/accessory-modal/accessory-modal.component';
import { PipesModule } from './pipes.module';
import { LaddaModule } from 'angular2-ladda';
import { AngularMultiSelectModule } from 'angular4-multiselect-dropdown/angular4-multiselect-dropdown';
import { PdfViewModal } from './modals/pdf-view-modal/pdf-view-modal.component';
import { ZplPreviewModalComponent } from './modals/zpl-preview-modal/zpl-preview.modal.component';
import { RfidLaminateModalComponent } from './modals/rfid-laminate-modal/rfid-laminate-modal.component';
import { RFIDValidation } from '../RFID/rfid-validation/rfid-validation.component';
import { RFIDQACheck } from '../RFID/rfid-qa-check/rfid-qa-check.component';
import { ChangeMachineModalComponent } from './modals/change-machine-modal/change-machine-modal.component';
import { CarouselModule } from 'ngx-bootstrap';
import { RFIDPackingSlipModal } from './modals/rfid-packing-slip-modal/rfid-packing-slip-modal.component';
import { StartPrintingModal } from './modals/start-printing-modal/start-printing-modal.component';
import { ApprovalModal } from './modals/approval-modal/approval-modal.component';
import { NgxBarcodeModule } from 'ngx-barcode';

@NgModule({
  imports: [
    CommonModule,
    AppRoutingModule,
    TranslateModule,
    FormsModule,
    ReactiveFormsModule,
    PipesModule,
    LaddaModule,
    AngularMultiSelectModule,
    PdfViewerModule,
    NgxBarcodeModule,
    CarouselModule.forRoot(),
    TypeaheadModule.forRoot()

  ],
  exports: [
    ButtonComponent,
    RolldownComponent,
    NAV_DROPDOWN_DIRECTIVES,
    // BreadcrumbsComponent,
    SIDEBAR_TOGGLE_DIRECTIVES,
    AsideToggleDirective,
    FocusDirective
  ],
  declarations: [
    CommentModal,
    EditadoSheetQaModal,
    PendingPrintModal,
    ReprintModal,
    RfidReprintModal,
    QaOkayModal,
    AccessoryModal,
    RFIDValidation,
    RFIDQACheck,
    WizardModal,
    SheetCountModal,
    PendingPrintCsModal,
    PdfViewModal,
    ZplPreviewModalComponent,
    RfidLaminateModalComponent,
    RFIDPackingSlipModal,
    ButtonComponent,
    RolldownComponent,
    ChangeMachineModalComponent,
    NAV_DROPDOWN_DIRECTIVES,
    // BreadcrumbsComponent,
    SIDEBAR_TOGGLE_DIRECTIVES,
    AsideToggleDirective,
    FocusDirective,
    ApprovalModal
    ,StartPrintingModal
  ],
  entryComponents: [
    CommentModal,
    EditadoSheetQaModal,
    PendingPrintModal,
    PdfViewModal,
    ZplPreviewModalComponent,
    RfidLaminateModalComponent,
    RFIDPackingSlipModal,
    ReprintModal,
    RfidReprintModal,
    QaOkayModal,
    AccessoryModal,
    RFIDValidation,
    RFIDQACheck,
    WizardModal,
    SheetCountModal,
    PendingPrintCsModal,
    ChangeMachineModalComponent,
    ApprovalModal
    ,StartPrintingModal
  ]
})
export class SharedModule { }



// WEBPACK FOOTER //
// /Users/jlam2/impresocloud/www/client/src/app/shared/shared.module.ts